import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SwitchProps {
    checked: boolean
    onChange: (checked: boolean) => void
    label: string
    tone?: 'primary' | 'light'
    className?: string
}

export const Switch: FC<SwitchProps> = ({
    checked,
    onChange,
    label,
    tone = 'primary',
    className
}): ReactNode => {
    return (
        <button
            type='button'
            role='switch'
            aria-checked={checked}
            aria-label={label}
            data-on={checked}
            onClick={() => onChange(!checked)}
            className={cn(
                'group relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full p-0.5 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2',
                tone === 'primary' ? 'bg-input data-[on=true]:bg-primary-strong' : 'bg-white/25 data-[on=true]:bg-primary',
                className
            )}
        >
            <span className='size-4 rounded-full bg-white shadow-card transition-transform duration-200 group-data-[on=true]:-translate-x-4' aria-hidden='true' />
        </button>
    )
}
